import DiagnosticWizard from "@/components/DiagnosticWizard";
import { Check } from "lucide-react";

export default function DiagnosticPage() {
  return (
    <div data-testid="diagnostic-page" className="bg-slate-50 min-h-screen">
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <p className="text-sm font-semibold text-green-600 uppercase tracking-wider mb-3">Diagnostic gratuit</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
              Quel est le potentiel de votre commerce ?
            </h1>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Une analyse complète en 6 étapes (Google, réseaux, site, supports, communication).
              Vous obtenez votre score de visibilité, votre potentiel d'amélioration et un plan
              d'action clair, avec une recommandation de pack personnalisée. Gratuit et sans engagement.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-slate-500">
              <span className="flex items-center gap-2"><Check size={16} className="text-green-600" /> Analyse en 6 étapes</span>
              <span className="flex items-center gap-2"><Check size={16} className="text-green-600" /> Rapport immédiat</span>
              <span className="flex items-center gap-2"><Check size={16} className="text-green-600" /> Plan d'action personnalisé</span>
            </div>
          </div>
          <DiagnosticWizard />
        </div>
      </section>
    </div>
  );
}
